import React from 'react';
import {
    FormControl, FormHelperText, InputLabel, Select
} from "@deere/fuel-react";
import {Controller} from "react-hook-form";
import {toCapitalize} from "./utils";

export const FormSelect = ({label, defValue, name, options, onTypeChange, control, required, isDisabled=false, showLabel=true, isShowSelect = true, isError=false, type}) => {
    const displayName = toCapitalize(name)
    return (
        <FormControl required={required} fullWidth error={isError}>
            {showLabel && (<InputLabel id={label}>{displayName}</InputLabel>)}
            <Controller
                rules={{required: required}}
                control={control}
                defaultValue={defValue}
                name={name}
                render={({onChange, value}) => (
                    <Select native
                            labelId={label}
                            id={name}
                            value={defValue}
                            disabled={isDisabled}
                            onChange={(e) => {
                                onChange(e);
                                onTypeChange && onTypeChange(e);
                            }}>
                        {isShowSelect && (<option value="">Select...</option>)}
                        {options && options.map((item) => {
                            return (
                                <option
                                    key={item.id}
                                    value={item.id}>{type === "overrideScore" ? item.reason : item.description}</option>
                            );
                        })}
                        }
                    </Select>
                )}
            />
            <FormHelperText>{isError && `${name} is a required field`}</FormHelperText>
        </FormControl>
    );
};
